import { useEffect } from 'react';
import { Button } from '@mui/material';

const TAWK_SRC = 'https://embed.tawk.to/69704a7bde57fd197cd10d80/1jffa5shi'; // <-- your widget

function loadTawk() {
  // already loaded?
  if (document.getElementById('tawk-script')) return;

  // create API object early so onLoad works
  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = new Date();

  // ✅ Hide the default bubble as soon as Tawk loads
  window.Tawk_API.onLoad = function () {
    try {
      window.Tawk_API.hideWidget();
    } catch {
      // ignore
    }
  };

  const s = document.createElement('script');
  s.id = 'tawk-script';
  s.async = true;
  s.src = TAWK_SRC;
  s.charset = 'UTF-8';
  s.setAttribute('crossorigin', '*');
  document.body.appendChild(s);
}

// ✅ open chat reliably when the script is ready
function maximizeWhenReady(maxTries = 24, intervalMs = 250) {
  let tries = 0;

  const tick = () => {
    tries += 1;

    if (window.Tawk_API?.maximize) {
      window.Tawk_API.maximize();
      return;
    }

    if (tries < maxTries) setTimeout(tick, intervalMs);
  };

  tick();
}

export default function VpLiveChatButton({ variant = 'outlined', size = 'small' }) {
  useEffect(() => {
    // optional preload:
    // loadTawk();
  }, []);

  const openLiveChat = () => {
    loadTawk();
    maximizeWhenReady();
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={openLiveChat}
      sx={{
        borderColor: '#fff',
        color: '#fff',
        bgcolor: 'rgba(255,255,255,0.08)',
        '&:hover': { bgcolor: 'rgba(255,255,255,0.18)', borderColor: '#fff' }
      }}
    >
      Live chat
    </Button>
  );
}
